import React from "react";
import MuiBox from "../MuiBox";

const TabPanel = ({ selectedValue, tabValue, children, sx }) => {
  if (selectedValue !== tabValue) return null;

  return (
    <MuiBox
      sx={{
        pt: "24px",
        fontFamily: "Inter",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        ...sx,
      }}
    >
      {children}
    </MuiBox>
  );
};

export default TabPanel;
